"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
class TeacherNotInClassesError extends client_library_1.ExtendableError {
    constructor() {
        super('Teacher is not part of any classes');
    }
}
exports.default = TeacherNotInClassesError;
//# sourceMappingURL=TeacherNotInClassesError.js.map